const ACTIVE_LOCALE = "en";
// Set to false to restore the language switcher and Chinese routes.
const ENGLISH_ONLY = true;

function getEnglishOnlyRedirect(route, englishOnly = ENGLISH_ONLY) {
  const locale = route.params && route.params.lang;

  if (!englishOnly || !locale || locale === ACTIVE_LOCALE) {
    return null;
  }

  const path = route.path.replace(/^\/[^/]+/, `/${ACTIVE_LOCALE}`);

  return {
    path,
    query: route.query,
    hash: route.hash,
    replace: true
  };
}

function resolveLocale(route, englishOnly = ENGLISH_ONLY) {
  if (englishOnly) {
    return ACTIVE_LOCALE;
  }

  return (route.params && route.params.lang) || ACTIVE_LOCALE;
}

module.exports = {
  ACTIVE_LOCALE,
  ENGLISH_ONLY,
  getEnglishOnlyRedirect,
  resolveLocale
};
